// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range-details-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 8px;
  max-width: 300px;
  margin: auto;
  font-family: Arial, sans-serif;
}

.range-header {
  background:  #2A8F9E;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 12px;
  border-radius: 8px 8px 0 0;
}

.range-content {
  padding: 10px;
}

.range-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 8px 0;
}

/* .label {
  font-weight: bold;
  color: #1e88e5;
}

.value {
  color: #333;
} */

.toggle-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 10px;
}

.reset-button {
  background: #c0ce81;
  color: white;
  font-size: 14px;
  font-weight: bold;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  display: block;
  width: 100%;
  /* margin-top: 15px; */
  transition: 0.2s ease-in-out;
}

.reset-button:hover {
  background: #e4e1e1;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/RangePolygon/RangePolygonDetails.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;;;;;GAOG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".range-details-container {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  padding: 8px;\n  max-width: 300px;\n  margin: auto;\n  font-family: Arial, sans-serif;\n}\n\n.range-header {\n  background:  #2A8F9E;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  padding: 12px;\n  border-radius: 8px 8px 0 0;\n}\n\n.range-content {\n  padding: 10px;\n}\n\n.range-item {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #ddd;\n  padding: 8px 0;\n}\n\n/* .label {\n  font-weight: bold;\n  color: #1e88e5;\n}\n\n.value {\n  color: #333;\n} */\n\n.toggle-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding-top: 10px;\n}\n\n.reset-button {\n  background: #c0ce81;\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  /* margin-top: 15px; */\n  transition: 0.2s ease-in-out;\n}\n\n.reset-button:hover {\n  background: #e4e1e1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
